import { render } from "./SystemLegalDocuments.vue?vue&type=template&id=423315e2&scoped=true"
import script from "./SystemLegalDocuments.vue?vue&type=script&lang=js"
export * from "./SystemLegalDocuments.vue?vue&type=script&lang=js"

import "./SystemLegalDocuments.vue?vue&type=style&index=0&id=423315e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423315e2"]])

export default __exports__